import { AuthService } from "./auth.service";
import { ResponseData } from "../../helpers/response";
import { IAuthUser } from "./interfaces";
import { Router } from "@angular/router";
import { IEvent } from "../../interfaces/event.interface";
import { ConfigService } from "../../services/config.service";
import { TokenService } from "./token.service";
import { MessageService } from "primeng/api";
import { HttpErrorResponse } from "@angular/common/http";
import { isUnauthorized } from "../../helpers/function";

export class ChangePasswordManager<T extends IAuthUser> implements IEvent {

  constructor(
    public service: AuthService<T>,
    public router: Router,
    public configService: ConfigService,
    public tokenService: TokenService,
    public toastr?: MessageService
  ) {
    this.service.model = this.service.getModelFromToken();

    if (!this.service.model.ChangePassword) {
      this.router.navigate(["/"]);
    }
  }

  changePassword() {
    if (this.service.model.Password == this.service.model.OldPassword) {
      const detail = "La nueva contraseÃ±a no puede ser igual a la anterior";

      if (this.toastr) {
        this.toastr.add({
          severity: "error",
          summary: "Cambio de contraseÃ±a",
          detail: detail
        });
        return;
      } else {
        this.onError("onError", detail);
      }
    }

    this.service.loading = true;

    this.service.changePassword(
      response => {
        this.service.loading = false;

        if (response.DataSource.Token) {
          this.tokenService.setToken(
            response.DataSource.Token,
            response.DataSource.RefreshToken
          );

          this.router.navigate(["/"]);
          this.onSuccess("onChangePassword", response);
        } else {
          if (this.toastr) {
            this.toastr.add({
              severity: "error",
              summary: "Inicio de sesiÃ³n",
              detail: "Token no encontrado"
            });
          }

          this.tokenService.removeToken();
        }
      },
      (error: HttpErrorResponse) => {
        if (isUnauthorized(error)) {
          this.router.navigate([this.configService.getAuthRoute().LoginUrl]);
        }

        this.onError("onError", error);
      }
    );
  }

  onSuccess(source: string, response: ResponseData) {
    this.service.loading = false;
    this.router.navigate(["/"]);
  }

  onError(source: string, error: string | ResponseData | HttpErrorResponse) {
    this.service.loading = false;
  }
}
